<template>
  <div class="chart-stats">
    <div v-if="series" class="chart-wrap">
      <Chart :options="opts" :series="eventsSeries" type="bar" width="100%" :height="200" />
    </div>
    <b-loading :is-full-page="false" v-model="isFetching" />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ChartStats',
  components: { Chart: VueApexCharts },
  props: {
    title: String,
    isFetching: Boolean,
    showEnqueued: Boolean,
    showStarted: Boolean,
    showFailed: Boolean,
    showFinished: Boolean,
    series: Array
  },
  data() {
    return {
    }
  },
  computed: {
    opts () {
      return {
        title: { text: this.title },
        colors: this.colors,
        chart: {
          toolbar: {
            show: false
          },
          sparkline: {
            enabled: false
          },
        },
        xaxis: {
          type: 'datetime'
        },
        tooltip: {
          x: {
            format: "MMM dd, hh:mm"
          }
        },
        dataLabels: {
          enabled: false
        }
      }
    },
    colors () {
      const colors = []
      if (this.showEnqueued) { colors.push('#c1c1c1') }
      if (this.showStarted) { colors.push('#00D1B2') }
      if (this.showFinished) { colors.push('#22b125') }
      if (this.showFailed) { colors.push('#FFDD57') }
      return colors
    },
    eventsSeries () {
      const selectedSeries = []
      if (this.showEnqueued) {
        selectedSeries.push({
          name: 'Enqueued',
          data: this.eventsEnqueued
        })
      }
      if (this.showStarted) {
        selectedSeries.push({
          name: 'Started',
          data: this.eventsStarted
        })
      }
      if (this.showFinished) {
        selectedSeries.push({
          name: 'Finished',
          data: this.eventsFinished
        })
      }
      if (this.showFailed) {
        selectedSeries.push({
          name: 'Failed',
          data: this.eventsFailed
        })
      }
      return selectedSeries
    },
    eventsStarted () {
      return this.series.map(x => [x.time, x.started])
    },
    eventsFinished () {
      return this.series.map(x => [x.time, x.finished])
    },
    eventsFailed () {
      return this.series.map(x => [x.time, x.failed])
    },
    eventsEnqueued () {
      return this.series.map(x => [x.time, x.enqueued])
    }
  },
}
</script>